<div class="header">
    <h2 class="ion-text-center">Unsaved Changes</h2>
    <ion-icon name="close" (click)="no()"></ion-icon>
</div>
<div class="content">
    <p>Do you wish to leave without making changes?</p>
</div>
<div class="button-container">
    <ion-button expand="block" shape="round" size="large" class="action-btn" (click)="no()">
        No, Keep Editing
    </ion-button>
    <ion-button expand="block" shape="round" size="large" class="action-btn" (click)="yes()">
        Yes, Discard Changes
    </ion-button>
</div>